<section class="page-control">
  <div class="flex justify-content-between w-full align-items-center">
    <h2>Radni nalozi</h2>
  </div>
</section>

<section class="page-control">
  <div class="grid w-full">
    <!-- FILTER FIELDS  -->
    <div class="col-12 sm:col-10">
      <form [formGroup]="form" class="grid">
        <div class="col-6 sm:col-4">
          <label class="mb-2 block">Broj šarže</label>
          <input
            ngDefaultControl
            pInputText
            type="text"
            class="w-100"
            formControlName="batch"
          />
        </div>

        <div class="col-6 sm:col-4">
          <label class="mb-2 block">Šifra proizvoda</label>
          <input
            ngDefaultControl
            pInputText
            type="text"
            class="w-100"
            formControlName="product_code"
          />
        </div>

        <div class="col-6 sm:col-4">
          <label class="mb-2 block">Naziv proizvoda</label>
          <input
            ngDefaultControl
            pInputText
            type="text"
            class="w-100"
            formControlName="product_name"
          />
        </div>
      </form>
    </div>

    <!-- FILTER BUTTONS -->
    <div
      class="flex flex-column justify-content-around col-12 sm:col-2 align-items-end"
    >
      <button class="main-btn w-10rem mt-2" (click)="onResetFilter()">
        Osveži <i class="pi pi-refresh"></i>
      </button>
    </div>
  </div>
</section>

<app-table
  [tableHeader]="fieldsService.tableHeader"
  [tableData]="workNips.data"
  [loading]="loading"
  (handlePageChange)="onPageChange($event)"
  [paginator]="workNips.pagination"
  [options]="{
    showEdit: true,
    showDelete: false
  }"
>
</app-table>
